import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import CheckCircle from "../images/check_circle.svg";
import Vector from "../images/Vector.svg";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./NewFeaturedPrograms.css"; // Updated to new CSS file

const FeaturedPrograms = () => {
  const navigate = useNavigate();
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [allPrograms, setAllPrograms] = useState([]);

  // Base URL for API calls
  const baseUrl =
    process.env.REACT_APP_NODE_ENV === "production"
      ? process.env.REACT_APP_PRODUCTION_BASE_URL
      : process.env.REACT_APP_DEVELOPMENT_BASE_URL;
  // Initial fetch to get first 3 programs and total pages
  useEffect(() => {
    const fetchInitialPrograms = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${baseUrl}/api/course/paginated?page=1&limit=3`
        );
        if (response.data.success) {
          setPrograms(response.data.data);
          console.log("programe", programs);
          setAllPrograms(response.data.data);
          setTotalPages(response.data.pagination.pages);
        }
      } catch (err) {
        setError("Failed to fetch programs");
        console.error("Error fetching programs:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchInitialPrograms();
  }, [baseUrl]);

  // Fetch all programs upfront for smoother sliding
  useEffect(() => {
    const fetchAllPrograms = async () => {
      if (totalPages > 1) {
        try {
          let allProgramsData = [...allPrograms];

          // Fetch remaining pages
          for (let page = 2; page <= totalPages; page++) {
            const response = await axios.get(
              `${baseUrl}/api/course/paginated?page=${page}&limit=3`
            );
            if (response.data.success) {
              allProgramsData = [...allProgramsData, ...response.data.data];
            }
          }

          setAllPrograms(allProgramsData);
        } catch (err) {
          console.error("Error fetching all programs:", err);
        }
      }
    };

    fetchAllPrograms();
  }, [totalPages, baseUrl]);

  const handleEnroll = (programId) => {
    navigate(`/program/${programId}`);
  };

  const renderProgramCard = (program) => (
    <div className="pricing-card">
      <h5>{program.programName}</h5>
      <div className="topd">
        <img src={Vector} alt="" />
        <p>{program.programDescription}</p>
      </div>
      <div className="price-section">
        <p className="price mb-0">
          <span className="currency">$</span>
          <span className="amount">
            {parseFloat(program.programPrice).toFixed(0)}
          </span>
          {/* <span className="duration">/month</span> */}
        </p>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleEnroll(program.courseId);
          }}
          className="btn1"
        >
          Enroll Now
        </button>
      </div>
    </div>
  );

  if (loading && programs.length === 0) {
    return <div className="text-center">Loading programs...</div>;
  }

  if (error) {
    return <div className="text-center text-danger">{error}</div>;
  }

  // Normalize and sort by sequence
  const normalizedPrograms = allPrograms
    .map((p) => ({
      ...p,
      showingDetails:
        typeof p.showingDetails === "string"
          ? JSON.parse(p.showingDetails)
          : p.showingDetails,
    }))
    .sort((a, b) => {
      // Handle null or undefined sequences safely
      const seqA = a.sequence ?? Number.MAX_SAFE_INTEGER;
      const seqB = b.sequence ?? Number.MAX_SAFE_INTEGER;
      return seqA - seqB;
    });

  return (
    <section className="featured_section pb-md-4 pe-md-5">
      <div>
        {/* Desktop View */}

        <h5 className="mainsliderprogramtext">Select Your Driving Program</h5>
        <div className="featurepagination d-none d-md-block">
          <Swiper
            modules={[Pagination]}
            spaceBetween={20}
            slidesPerView={1}
            pagination={{ clickable: true }}
            className="featured-programs-swiper desktop-swiper"
            speed={800}
            loop={true}
            breakpoints={{
              768: {
                slidesPerView: 1,
                spaceBetween: 5,
              },
              992: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              1200: {
                slidesPerView: 1,
                spaceBetween: 30,
              },
            }}
          >
            {normalizedPrograms.map((program) => (
              <SwiperSlide key={program.courseId}>
                {renderProgramCard(program)}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Mobile View */}
        <div className="featurepagination d-block d-md-none">
          <Swiper
            modules={[Pagination]}
            spaceBetween={15}
            slidesPerView={1}
                    pagination={{ clickable: true }}
            className="featured-programs-swiper"
            speed={800}
            loop={true}
            centeredSlides={true}
          >
            {normalizedPrograms.map((program) => (
              <SwiperSlide key={program.courseId}>
                {renderProgramCard(program)}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default FeaturedPrograms;
